import Image from "next/image";
import Breadcrumb from "@/Components/Breadcrumb/Breadcrumb";

interface BannerProps {
  isMobile?: boolean;
  data?: {
    title?: string;
    desc?: string;
    description?: string;
    banner_image?: { data?: { attributes?: { url?: string } } };
    banner_image_mobile?: { data?: { attributes?: { url?: string } } };
  };
  breadcrumbs?: { item?: any[] };
}

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";

const Banner: React.FC<BannerProps> = ({
  data = {},
  breadcrumbs,
  isMobile,
}) => {
  const {
    title = "",
    desc = "",
    description = "",
    banner_image,
    banner_image_mobile,
  } = data;

  const desktopBanner =
    banner_image?.data?.attributes?.url &&
    `${baseUrl}${banner_image.data.attributes.url}`;

  const mobileBanner = banner_image_mobile?.data?.attributes?.url
    ? `${baseUrl}${banner_image_mobile.data.attributes.url}`
    : "/images/crm/mobile-bg.png";

  return (
    <section className="relative bg-background-dark text-white pt-[140px] md:pt-[154px] xl:pt-[180px] py-[56px] md:py-[80px] xl:py-[100px] overflow-hidden">
      {/* Background Images */}
      {/* <Image
        src="/images/consulting/banner-top.png"
        width={571}
        height={571}
        alt="banner-vector"
        className="absolute w-[571px] h-[571px] top-[-80px] left-0 z-1 bg-cover bg-no-repeat bg-center sm:block"
        quality={80}
        loading="eager"
        priority
      />
      <Image
        src="/images/consulting/banner-bottom.png"
        width={470}
        height={470}
        alt="banner-vector"
        className="absolute w-[470px] bottom-0 top-[auto] right-0 z-1 bg-cover bg-no-repeat bg-center sm:block"
        quality={80}
        loading="eager"
        priority
      /> */}

      {/* Content */}
      <div className="container mx-auto px-4 text-center relative z-10">
        {(breadcrumbs?.item?.length ?? 0) > 0 && (
          <Breadcrumb
            items={breadcrumbs?.item ?? []}
            className="text-gray-300 xl:mb-[32px] md:mb-[16px] mb-[16px] xl:mt-[0] whitespace-nowrap overflow-hidden w-[95%] text-ellipsis flex-row text-subtitle-3 md:text-subtitle-3 md:mt-[0] flex items-center justify-center"
            className2="text-gray-300 text-subtitle-3"
          />
        )}

        <h2 className="text-display font-extrabold text-primary-text-white uppercase max-w-[1230px] mx-auto mb-[32px]">
          {title}
        </h2>

        {/* Banner Image */}
        <div className="flex items-center justify-center mb-[32px] w-full">
          {!isMobile
            ? desktopBanner && (
                <Image
                  src={desktopBanner}
                  alt="banner desktop"
                  width={1081}
                  height={415}
                  quality={100}
                  className="h-[415px] min-h-[415px] max-h-[415px] w-full xl:object-cover object-cover sm:block hidden"
                  priority
                />
              )
            : isMobile && (
                <Image
                  src={mobileBanner}
                  alt="banner mobile"
                  width={1081}
                  height={415}
                  quality={100}
                  className="h-[415px] min-h-[415px] max-h-[415px] w-full xl:object-cover object-cover sm:hidden block"
                  priority
                />
              )}
        </div>

        <div className="grid text-start grid-cols-12">
          <div className="xl:col-span-12 col-span-12 md:col-span-12">
            <p className="text-secondary-text-white text-subtitle-2 font-regular mb-2 sm:text-left text-center">
              {desc}
            </p>
            <p className="text-secondary-text-white text-subtitle-2 font-regular sm:text-left text-center">
              {description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
